import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
import { __decorate } from "tslib";
import CenterCenter from '@/components/layout/CenterCenter.vue';
import MainTitle from '@/components/title/MainTitle.vue';
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import slugify from '@sindresorhus/slugify';
import NativeColorPicker from '@/components/color-picker/NativeColorPicker.vue';
import store from '@/store';
import { CLUSTER_LIST, PLATFORM_CREATE } from '@/store/actions/platforms';
import { PlatformCreateParams } from '@/store/models/platform';
import { CLUSTER_DOMAIN } from '@/store/actions/api';
import WLabel from "@/components/wrapper/w-label.vue";
var CreatePlatform = /*#__PURE__*/function (_Vue) {
  function CreatePlatform() {
    var _this;
    _classCallCheck(this, CreatePlatform);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CreatePlatform, [].concat(args));
    _defineProperty(_this, "togglePlatformCreationDialog", void 0);
    _defineProperty(_this, "visible", false);
    _defineProperty(_this, "loading", false);
    _defineProperty(_this, "errorMsg", '');
    // form value
    _defineProperty(_this, "name", '');
    _defineProperty(_this, "url", '');
    _defineProperty(_this, "title", '');
    _defineProperty(_this, "color", '');
    _defineProperty(_this, "logoDataUrl", '');
    _defineProperty(_this, "loadData", false);
    return _this;
  }
  _inherits(CreatePlatform, _Vue);
  return _createClass(CreatePlatform, [{
    key: "mounted",
    value: function mounted() {
      var _this2 = this;
      // we load the list of cluster
      this.loading = true;
      store.dispatch(CLUSTER_LIST).then(function (resp) {
        _this2.loading = false;
      }).catch(function (err) {
        _this2.loading = false;
        _this2.errorMsg = err;
      });
    }
  }, {
    key: "autoFillUrl",
    value: function autoFillUrl(value) {
      this.name = value;
      if (this.name !== '') {
        var enhancedName = slugify(this.name);
        this.url = "https://".concat(enhancedName, ".").concat(CLUSTER_DOMAIN);
      } else {
        this.url = '';
      }
    }
  }, {
    key: "updateTitle",
    value: function updateTitle(value) {
      this.title = value;
    }
  }, {
    key: "slugifyPlatformName",
    value: function slugifyPlatformName() {
      this.name = slugify(this.name);
    }
  }, {
    key: "colorSelection",
    value: function colorSelection(value) {
      this.color = value;
    }
  }, {
    key: "onFileSelected",
    value: function onFileSelected(fileData) {
      var file = fileData.raw;
      this.loadData = true;
      var reader = new FileReader();
      reader.onloadend = this.loadLogo;
      reader.readAsDataURL(file);
    }
  }, {
    key: "loadLogo",
    value: function loadLogo(e) {
      this.logoDataUrl = e.target.result;
      this.loadData = false;
    }
  }, {
    key: "clusters",
    value: function clusters() {
      return store.getters.clusters;
    }
  }, {
    key: "canBeSubmitted",
    value: function canBeSubmitted() {
      var _this$name, _this$logoDataUrl, _this$color;
      return ((_this$name = this.name) === null || _this$name === void 0 ? void 0 : _this$name.trim()) && ((_this$logoDataUrl = this.logoDataUrl) === null || _this$logoDataUrl === void 0 ? void 0 : _this$logoDataUrl.trim()) && ((_this$color = this.color) === null || _this$color === void 0 ? void 0 : _this$color.trim());
    }
  }, {
    key: "createPlatform",
    value: function createPlatform(clusterID) {
      var _this3 = this;
      this.errorMsg = '';
      this.loading = true;
      if (clusterID === undefined) {
        if (this.clusters().length > 0) {
          clusterID = this.clusters()[0];
        } else {
          this.loading = false;
          this.errorMsg = 'no cluster aivalable';
          return;
        }
      }
      var params = new PlatformCreateParams(this.name, this.url, this.logoDataUrl, clusterID, this.color, this.title);
      store.dispatch(PLATFORM_CREATE, params).then(function (resp) {
        _this3.onDialogClose();
        _this3.loading = false;
        _this3.errorMsg = '';
      }).catch(function (err) {
        _this3.loading = false;
        _this3.errorMsg = err;
      });
    }
  }, {
    key: "onDialogClose",
    value: function onDialogClose() {
      this.visible = false;
      this.$emit("dialogClose");
    }
  }]);
}(Vue);
__decorate([Prop({
  default: false
})], CreatePlatform.prototype, "togglePlatformCreationDialog", void 0);
CreatePlatform = __decorate([Options({
  components: {
    WLabel: WLabel,
    NativeColorPicker: NativeColorPicker,
    CenterCenter: CenterCenter,
    MainTitle: MainTitle
  },
  data: function data() {
    return {
      CLUSTER_DOMAIN: CLUSTER_DOMAIN
    };
  },
  watch: {
    togglePlatformCreationDialog: function togglePlatformCreationDialog() {
      this.visible = this.togglePlatformCreationDialog;
    }
  }
})], CreatePlatform);
export default CreatePlatform;